import { cx } from '@linaria/core';
import { ReactNode, memo, useCallback } from 'react';
import { AppRouter, routeConfigs } from '../../state/state.router';
import { routerPush } from '../../utilities/router';
import "./Link.linaria.module.css!=!./Link?./Link.linaria.module.css?css=H4sIAAAAAAAAA2WQzU7DMBCE77wF4gKHVDXQOpiHsexknbhZryvb+bV4d1TUVIk4zny72pk9qOQkR8m6kZP7zJVHH4SlFoJN3z9Phxv/ipL1CJPRubbximoWGn3VrbyVrD37S7/sVVZoGypsAhdFBZQgrBscZX/mhsX7wRdjzOPaRSbs4Ii56kP0QVy93e7e0qRptAM+0hiEacXKyU5zGpZ8cwVb/VDLBufRuJxgSkUNlQ8qWU+CPMEmGHO67JHWZJzzLZzP5eU03OGgwmtRNAGACrTUvT1bd/UhKXr8roqypA/2rvcqG0+pGME2bRLaY72Z14Yab/ZqN386HjetypiGpfvXqqcaAtq/ar9MKZJm5gEAAA=="
const _block = "atm_7l_1kw7nm4 atm_9s_1ulexfb";
const _expand = "atm_h_1h6ojuz atm_7l_u67f1s atm_9j_tlke0l atm_9s_1txwivl atm_am_kb7nvz atm_rd_glywfm";
const _inline = "atm_7l_1mb8uln atm_9j_tlke0l atm_rd_glywfm";
const _logo = "atm_h_1h6ojuz atm_9s_1txwivl atm_rd_glywfm";
const _mfc = "atm_7l_1y68j5v atm_9j_tlke0l atm_cs_8n312b";
const _thin = "atm_cs_bfngof";
const _nav = "atm_9s_1txwivl atm_h_1h6ojuz atm_7l_u67f1s atm_9j_tlke0l atm_rd_glywfm";
const _text = "atm_9j_tlke0l atm_rd_glywfm";
const _underline = "atm_rd_8stvzk";
const getRootStyles = (props: ILink) => {
  const {
    actionLink,
    block,
    href,
    inline,
    logo,
    thin,
    mfc,
    nav,
    text,
    underline
  } = props;
  if (nav) return _nav;
  if (actionLink) return cx(_inline, mfc && _mfc, thin && _thin, underline && _underline);
  if (text && mfc) return cx(_mfc, thin && _thin);
  if (!inline && !logo) return _expand;
  if (href?.startsWith('http') && !inline && !logo && !block) return _expand;
  return cx(block && _block, inline && _inline, logo && _logo, mfc && _mfc, text && _text, underline && _underline, thin && _thin);
};
interface ILink {
  className?;
  disabled?: boolean;
  onClick?(event?: any): void;
  actionLink?: boolean;
  underline?: boolean;
  children: ReactNode;
  inline?: boolean;
  block?: boolean;
  text?: boolean;
  href?: string;
  logo?: boolean;
  thin?: boolean;
  mfc?: boolean;
  nav?: boolean;
  /** external (http) hrefs only; defaults to a new tab */
  target?: '_blank' | '_self';
  title?: string;
  page?: 'rooms' | 'messages' | 'chat-archives' | 'recommendations' | 'home' | 'search' | 'friends' | 'model-browser' | 'private-gallery' | 'miss-mfc' | 'notes' | 'mail' | 'news';
}
const Link = memo((props: ILink) => {
  const {
    className,
    disabled,
    onClick = () => {},
    actionLink,
    children,
    text,
    href,
    mfc,
    target = '_blank',
    title,
    page
  } = props;
  const rootStyles = getRootStyles(props);
  const onNavIntention = useCallback(async () => {
    // don't preload for the route that you are already on
    if (page && AppRouter.route.visiblePage !== page) {
      const foundRoute = routeConfigs.get(page);
      if (!foundRoute) {
        console.warn('[Link] No route config found for page:', page);
        return;
      }
      if (foundRoute.preload) {
        // check if already cached
        if (AppRouter.route.preloadCache.has(page)) {
          return;
        }

        // store in cache
        const promise = foundRoute.preload();
        AppRouter.route.preloadCache.set(page, {
          promise,
          timestamp: Date.now()
        });

        // if skipAwait is false, wait for the promise
        if (!foundRoute.skipAwait) {
          await promise;
        }
      }
    }
  }, [page]);
  if (text && mfc || actionLink) {
    // only used for the Empty components at the moment.  also referenced in the dead You May Like search results
    return <span title={title} onClick={disabled ? null : onClick} onMouseEnter={onNavIntention} className={cx(rootStyles, className)}>
                {children}
            </span>;
  }
  if (href && href.startsWith('http')) {
    return <a rel="noopener noreferrer" target={target} href={href} title={title} className={cx(rootStyles, className)}>
                {children}
            </a>;
  }
  return <a title={title} onMouseEnter={onNavIntention} onClick={disabled ? null : () => {
    const resolvedHref = '/' + (page ? routeConfigs.get(page).paths[0] : href);
    routerPush(resolvedHref);
  }} className={cx(rootStyles, className)}>
            {children}
        </a>;
});
export default Link;